import { WorkflowsPermissions } from './workflows.orders.permissions';

export class WorkflowsManagementPermissions {
  static Workflows = WorkflowsPermissions?.Permissions;
}

export function getWorkflowsModuleName() {
  return 'WorkflowManagement';
}
